export default class Lib {
    constructor() {
        throw new TypeError('Lib must not be instantiated');
    }

    /**
     * Get a collection of Node's
     *
     * @param {String|NodeList|Node} element
     * @returns {Node[]}
     */
    static dom(element) {
        if (arguments.length > 1) {
            const remainingArguments = Array.prototype.slice.call(arguments, 1);

            return Lib.dom(element).concat(Lib.dom.apply(this, remainingArguments));
        }

        if (typeof element === 'undefined' || element === null) {
            return [];
        }
        if (typeof element === 'string') {
            return Lib.dom(document.querySelectorAll(element));
        }

        if (element && element.nodeType > 0) {
            /** @type {Node} element */
            return [element];
        }

        return Array.prototype.slice.call(element);
    };

    /**
     * Apply the given callback to each element in the given collection
     *
     * @param {*[]|NodeList|Node[]} collection
     * @param {function} callback
     * @returns {*[]}
     */
    static map(collection, callback) {
        if (typeof callback !== 'function') {
            throw new TypeError('Argument callback must be a function');
        }

        return Array.prototype.map.call(collection, callback);
    };

    /**
     * Apply the given callback to each element in the given collection
     *
     * @param {*[]|NodeList|Node[]} collection
     * @param {function} callback
     * @returns {*[]}
     */
    static flatMap(collection, callback) {
        if (typeof callback !== 'function') {
            throw new TypeError('Argument callback must be a function');
        }

        const arrayPrototype = Array.prototype;

        return arrayPrototype.concat.apply([], arrayPrototype.map.call(collection,
            i => arrayPrototype.slice.call(callback(i))
        ));
    };

    /**
     * Filter the given collection
     * @param {Node[]|NodeList} collection
     * @param {function} [callback]
     * @returns {*}
     */
    static filter(collection, callback = null) {
        if (null === callback) {
            callback = function (item) {
                return !!item;
            }
        }
        return Array.prototype.filter.call(collection, callback);
    };

    /**
     * Add an event listener to all elements in the given collection
     *
     * @param {Node[]|NodeList} collection
     * @param {string} eventName
     * @param {function} callback
     */
    static addEventListener(collection, eventName, callback) {
        if (typeof eventName !== 'string') {
            throw new TypeError('Argument eventName must be a string');
        }
        if (typeof callback !== 'function') {
            throw new TypeError('Argument callback must be a function');
        }
        Lib.map(collection, function (elements) {
            Lib.dom(elements).forEach(element => {
                element.addEventListener(eventName, function (event) {
                    callback(event, this)
                });
            })
        });
    };

    /**
     * Returns the data value
     *
     * @param {HTMLElement} element
     * @param {string} dataAttribute
     * @returns {*|string}
     */
    static data(element, dataAttribute) {
        return element.getAttribute('data-' + dataAttribute);
    };
}



// WEBPACK FOOTER //
// ./Resources/Private/JavaScripts/src/Lib.js